import React from "react";

type JsonLdProps = {
  data: Record<string, any>;
  scriptKey?: string;
};

export function JsonLd({ data, scriptKey }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      id={scriptKey}
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, "\\u003c") }}
    />
  );
}
